import PopOverMenu from "view/components/PopOverMenu";
import { RowsActionsProps } from "../../types";
import PerimeterIcon from "assets/icons/HeroIcons/PerimeterIcon";
import ActionDropDownMenu from "Components/ActionDropDownMenu";
import usePermissions from "hooks/usePermissions";

export const RowsActions = ({
  getReportsActions,
  row,
}: RowsActionsProps) => {
  return (
    <div className="flex items-center justify-start flex-grow svg-container">
    <div className="flex justify-end items-center flex-grow relative py-0.5 pr-5">
        {getReportsActions(row.original).some(
          (action: any) => action.isVisible === true
        ) ? (
          <PopOverMenu icon={<PerimeterIcon />}>
            <ActionDropDownMenu
              data={row.original}
              actions={getReportsActions(row.original)}
            />
          </PopOverMenu>
        ) : (
          <PerimeterIcon className="mr-8" />
        )}
      </div>
    </div>
  );
};
